import { TitlePipe } from './title.pipe';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: false,
})
export class FilterPipe implements PipeTransform {
  transform(
    options: any[],
    searchTerm: string,
    valueLabel: string = null,
    applyTitle = false,
    seperator = '_',
  ): any {
    if (!searchTerm) {
      return options;
    }
    return options.filter((option) => {
      let modifiedOption = option;
      if (applyTitle) {
        const title = new TitlePipe();
        modifiedOption = title.transform(option, seperator);
      }
      const value = valueLabel
        ? modifiedOption[valueLabel]?.toString()?.toLowerCase()
        : modifiedOption?.toString()?.toLowerCase();
      return value.indexOf(searchTerm.toLowerCase()) > -1;
    });
  }
}
